import { Path, Svg } from "@react-pdf/renderer";

export const AnimalLogo = (): JSX.Element => {
	return (
		<Svg width="15" height="15" viewBox="0 0 30 30">
			<Path
				d="M12.324 3.96c.325 2.476-.812 4.705-2.6 4.994-1.747.289-3.453-1.445-3.819-3.92C5.58 2.556 6.718.327 8.465.04c1.828-.33 3.534 1.444 3.86 3.92zm3.9 4.994c-1.787-.29-2.925-2.559-2.6-4.994.325-2.476 2.031-4.21 3.86-3.92 1.746.288 2.924 2.517 2.559 4.993-.325 2.476-2.072 4.21-3.819 3.92zm-9.75.784c.325 2.476-.812 4.705-2.6 4.994C2.127 15.02.421 13.287.055 10.81c-.325-2.476.813-4.705 2.6-4.994 1.747-.289 3.453 1.445 3.82 3.921zm13 .041c-.325 2.476.813 4.705 2.6 4.994 1.747.289 3.453-1.445 3.819-3.92.325-2.477-.813-4.706-2.6-4.994-1.747-.33-3.453 1.444-3.819 3.92zm-6.5.578c2.803 0 3.94 2.765 6.663 4.127 4.265 2.146 5.403 8.543 1.015 10.482-2.194.988-3.378.577-4.717.112-.843-.293-1.746-.607-3.002-.607-1.23 0-2.12.304-2.952.587-1.337.456-2.522.86-4.726-.133-4.306-1.94-3.25-8.295 1.057-10.441 2.721-1.403 3.859-4.127 6.662-4.127z"
				fill="#20CDB8"
				fill-rule="evenodd"
			/>
		</Svg>
	);
};
